import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-pdf-preview',
  templateUrl: './pdf-preview.component.html',
  styles: ``
})
export class PDFPreviewComponent {
  @Input() PDF_Url!: string;
  @Output() close = new EventEmitter(false);
  constructor(private sanitizer: DomSanitizer) { }

  safeLink(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
